export const SYMBOL_ARROW_SIZE = 1;
